/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import baseUrl from "../../Environment";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Divider,
  Avatar,
  Box,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
const UserProfile = () => {
  const [userData, setUserData] = useState();
  const phoneNumber = localStorage.getItem("phoneNumber");
  const LoadUser = async () => {
    try {
      const data = await axios
        .get(`${baseUrl}user/get/${phoneNumber}`)
        .then((response) => response.data);
      if (data) {
        setUserData(data.user.users);
       
      }
    } catch (error) {}
  };

  useEffect(() => {
    LoadUser();
  }, [phoneNumber]);
  return (
    <Grid
    container
    justifyContent="center"
    alignItems="center"
    sx={{ mt: 5, px: 2 }}
  >
    <Card
      sx={{
        width: "110%",
        maxWidth: 700,
        borderRadius: 5,
        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.15)",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#bad3e7",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "24px 0",
        }}
      >
        <Avatar
          sx={{
            backgroundColor: "white",
            color: "#1976d2",
            width: 80,
            height: 80,
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          }}
        >
          <AccountCircleIcon sx={{ fontSize: 60 }} />
        </Avatar>
      </Box>
      <Typography
        variant="h5"
        align="center"
        sx={{
          fontWeight: "bold",
          color: "#1976d2",
          mt: 2,
        }}
      >
        Your Profile
      </Typography>
      <Divider sx={{ margin: "16px 24px" }} />
      {userData &&
        userData.map((user, index) => (
          <CardContent key={index} sx={{ padding: "24px" }}>
            <Grid container spacing={2}>
              {[
                { label: "Name", value: user.name },
                { label: "Email", value: user.email },
                { label: "Phone No", value: user.phoneNumber },
                { label: "Role", value: user.role },
                {
                  label: "Date",
                  value: new Intl.DateTimeFormat("en-US", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                  }).format(new Date(user.createdAt)),
                },
              ].map((field, idx) => (
                <Grid container item xs={12} key={idx}>
                  <Grid item xs={4}>
                    <Typography
                      variant="subtitle1"
                      fontWeight="medium"
                      color="text.secondary"
                    >
                      {field.label}:
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography
                      variant="body1"
                      sx={{
                        backgroundColor: "#f4f6f8",
                        padding: "8px 16px",
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                      }}
                    >
                      {field.value}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </CardContent>
        ))}
    </Card>
  </Grid>
  );
};

export default UserProfile;
